// utils/media/stopAllPageMedia.js

export function stopAllPageMedia() {
  document.querySelectorAll("video, audio").forEach((media) => {
    media.pause();
    media.currentTime = 0;
  });

  window.dispatchEvent(new CustomEvent("stop-embedded-media"));
}
